import React, { useState, useEffect } from 'react';
import { TrendingUp, Users, Eye } from 'lucide-react';

const LiveInterestIndicator = ({ serviceName }) => {
  const [count, setCount] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Messages pool for variation
  const messages = [
    { icon: TrendingUp, text: 'businesses exploring this service' },
    { icon: Users, text: 'founders checking this service today' },
    { icon: Eye, text: 'users reviewing this service' },
    { icon: TrendingUp, text: 'interested in this service right now' },
  ];

  const [currentMessage, setCurrentMessage] = useState(messages[0]);

  // Generate random count between 1-500
  const generateRandomCount = () => {
    return Math.floor(Math.random() * 500) + 1;
  };

  useEffect(() => {
    // Set initial count
    setCount(generateRandomCount());

    // Update count every 10 seconds
    const interval = setInterval(() => {
      setIsAnimating(true);
      
      setTimeout(() => {
        setCount(generateRandomCount());
        // Randomly change message occasionally
        if (Math.random() > 0.6) {
          setCurrentMessage(messages[Math.floor(Math.random() * messages.length)]);
        }
        setIsAnimating(false);
      }, 300);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const IconComponent = currentMessage.icon;

  return (
    <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg px-4 py-2.5 shadow-sm hover:shadow-md transition-all duration-300" data-testid="live-interest-indicator">
      <IconComponent className="text-blue-600" size={18} />
      <span className={`font-semibold text-blue-700 transition-all duration-300 ${isAnimating ? 'scale-110' : 'scale-100'}`}>
        {count}
      </span>
      <span className="text-sm text-slate-700">
        {currentMessage.text}
      </span>
    </div>
  );
};

export default LiveInterestIndicator;
